import { createSelector } from 'reselect'

import { selectCommitmentState } from './selectCommitmentState'

export const selectCommitmentItemsLoadingStatus = createSelector(
  [selectCommitmentState],
  (state) => state.commitmentItems.status
)
